import { render, staticRenderFns } from "./ProjectTemplateModal.vue?vue&type=template&id=6b24d382&scoped=true&"
import script from "./ProjectTemplateModal.vue?vue&type=script&lang=js&"
export * from "./ProjectTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTemplateModal.vue?vue&type=style&index=0&id=6b24d382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b24d382",
  null
  
)

export default component.exports